import { useEffect, useState } from 'react';
import { useParams, useLocation, Redirect, useHistory } from 'react-router-dom';
import jwtDecode from '../utils/jwt';
import { auth } from '../utils/auth';
import { useSnackbar } from 'notistack';

function LoginPage() {
  const history = useHistory();
  const location = useLocation();
  const { token } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [result, setResult] = useState(null);

  if (!token) {
    history.push('/users/sign_in');
  }

  useEffect(() => {
    if (!token) { return; }

    try {
      const decodedToken = jwtDecode(token);
      auth.login(token);
      setResult({ ok: true, decodedToken });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Your session has expired for security reasons. Please log in again.', {
        // 'warning' is orange and blends into this page's orange background; use 'error' instead.
        variant: 'error',
        autoHideDuration: 8000,
      });
      setResult({ ok: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (!result) {
    return null;
  }

  if (!result.ok) {
    return <Redirect to="/users/sign_in" />;
  }

  const needsOnboarding = new URLSearchParams(location.search).get('needs_onboarding') === 'true';
  if (needsOnboarding) {
    window.location.href = `${process.env.REACT_APP_AUTH_HOST}/users/onboarding`;
    return null;
  }

  return (
    <Redirect
      to={result.decodedToken.site_id ? '/sites/' + result.decodedToken.site_id : '/'}
    />
  );
}

export default LoginPage;
